import axios from "axios";

// 1. Send Email OTP
export const sendEmailOtp = async (formData, navigate) => {
    try {
        const { data } = await axios.post(
            "https://dev-44ekppmh6lkd6qjq.us.auth0.com/passwordless/start",
            {
                client_id: "SVlio4lrsOTpSBYwYT4xoWMHGiEgFUkN",
                connection: "email",
                send: "code",
                email: formData.email
            },
            { headers: { "Content-Type": "application/json" } }
        );

        console.log("✅ Email OTP sent!", data);
        navigate("/otp-verification", { state: { email: formData.email } });
    } catch (error) {
        console.error("❌ Email OTP error:", error.response?.data || error.message);
        alert("Failed to send email OTP. Try again.");
    }
};

// 2. Verify OTP
export const verifyEmailOtp = async (email, otpCode, navigate) => {
    try {
        const { data } = await axios.post(
            "https://dev-44ekppmh6lkd6qjq.us.auth0.com/oauth/token",
            {
                grant_type: "http://auth0.com/oauth/grant-type/passwordless/otp",
                client_id: "SVlio4lrsOTpSBYwYT4xoWMHGiEgFUkN",
                otp: otpCode,
                realm: "email",
                username: email,
                scope: "openid profile email"
            },
            { headers: { "Content-Type": "application/json" } }
        );

        console.log("🔓 Logged in:", data);
        localStorage.setItem("access_token", data.access_token);
        navigate("/dashboard");
    } catch (error) {
        console.error("❌ Login failed:", error.response?.data || error.message);
        alert("Invalid or expired code. Try again.");
    }
};

// 3. Send Reset Password Email
export const sendResetPasswordEmail = async (email) => {
    try {
        const { data } = await axios.post(
            "https://dev-44ekppmh6lkd6qjq.us.auth0.com/dbconnections/change_password",
            {
                client_id: "SVlio4lrsOTpSBYwYT4xoWMHGiEgFUkN",
                email,
                connection: "Username-Password-Authentication"
            },
            { headers: { "Content-Type": "application/json" } }
        );

        console.log("📬 Reset email sent:", data);
        alert("Check your email to reset your password.");
    } catch (error) {
        console.error("❌ Reset error:", error.response?.data || error.message);
        alert("Failed to send reset link.");
    }
};



// 4. Google OAuth Login
export const googleLogin = async (token) => {
    try {
      const { data } = await axios.post(
        "https://api.cjetdispatch.com/api/auth/oauth/google",
        // "http://localhost:5050/api/auth/oauth/google",
        { token },
        { headers: { "Content-Type": "application/json" } }
      );
      return data;
    } catch (error) {
      console.error("❌ Google login error:", error.response?.data || error.message);
      throw new Error(error.response?.data?.error || "Google login failed");
    }
  };